import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { AccordionPanel, CheckboxGroup, Text } from 'reaxl';
import _get from 'lodash/get';
import FilterTitle from '../FilterTitle';
import FilterCheckboxLabel from '../FilterCheckboxLabel';

/**
 *  FilterCondition is a custom Filter component that is designed to be used as a Custom Filter type in the Filters Component.
 *  It allows the user to add a node above filters.
 *
 */
function FilterCondition(_ref) {
  let {
    collapsed,
    collapsedTitle,
    filter = {},
    filtersOrder,
    onOptionChange = () => {},
    values = {},
    ...rest
  } = _ref;
  const selectedListingTypes = filter.value;
  const chkGrpOptions = filter.options.map(option => ({
    label: /*#__PURE__*/React.createElement(FilterCheckboxLabel, option),
    value: option?.value
  }));

  // Remove any non-DOM attributes from props
  delete rest.onOptionsClear;
  delete rest.resultCount;
  const getValue = (valuesSelected, name) => [].concat(_get(valuesSelected, name, []));
  const getFilterTitle = (value, label) => {
    const valueCount = value.length;
    let filterTitle = label;
    if (valueCount > 0) {
      filterTitle = /*#__PURE__*/React.createElement(React.Fragment, null, label, ' ', /*#__PURE__*/_jsx(Text, {
        weight: "normal",
        color: "subdued-lighter"
      }, void 0, `(${valueCount} selected)`));
    }
    return /*#__PURE__*/_jsx(FilterTitle, {
      title: filterTitle
    }, "filter-title");
  };
  const CheckboxFilterData = (filterSelected, valuesSelected) => {
    const {
      label,
      name
    } = filterSelected;
    const value = getValue(valuesSelected, name);
    const title = getFilterTitle(value, label);
    return {
      name,
      title
    };
  };
  const filterData = CheckboxFilterData(filter, values);
  return /*#__PURE__*/React.createElement(AccordionPanel, Object.assign({
    "data-cmp": "filterCondition",
    eventKey: filter.name,
    title: filterData.title
  }, rest), filter.prependNode, /*#__PURE__*/_jsx(CheckboxGroup, {
    name: "listingTypes",
    value: selectedListingTypes,
    columnClasses: "col-xs-4 col-lg-2",
    options: chkGrpOptions,
    onChange: event => onOptionChange(event, filter)
  }), filter.children);
}
export default FilterCondition;